import * as Yup from 'yup';

export interface EditProgrammeModel {
  type: string;
}

export const editProgrammeSchema = Yup.object().shape({
  type: Yup.string().required(),
});
